<script>
  import options from './DeleteProfileFlow.options'
  export default options
</script>

<template>
  <article class="kb-delete-profile-flow">
    
    <div class="kb-delete-profile-flow-header">

      <ul v-if="steps.length > 1" class="kb-delete-profile-flow-header__step-indicator">

        <li v-for="(step, index) in steps" class="kb-delete-profile-flow-header__step-indicator-list-item">
          <div 
            class="kb-delete-profile-flow-header__step-indicator-circle" 
            :class="{'kb-delete-profile-flow-header__step-indicator-circle--active-step': index === currentStepIndex}">
            <p>{{ index+1 }}</p>
          </div>
          <strong>{{ getStepTitle(step) }}</strong>
        </li>

      </ul>

      <h1 class="kb-delete-profile-flow-header__title"> {{ getLabel('title') }}</h1>
        
      <div class="kb-delete-profile-flow-header__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z"></path></svg>
      </div>

      <p class="kb-delete-profile-flow-header__description">
        {{ getLabel('description') }}
      </p>

    </div>

    <div class="kb-delete-profile-flow-body">

      <section v-if="currentStep === FlowSteps.CANCERFORUM" class="kb-delete-profile-flow-body__step">
        <h2>
          {{ getLabel('cancerforumTitle') }}
        </h2>
        <div class="kb-rich-text">
          <div class="kb-rich-text__content" v-html="decodeHtml(getLabel('cancerforumDescription'))"></div>
        </div>
        <ul class="kb-delete-profile-flow-body__step--radio">
          <li>
            <input type="radio" name="cancerforum-delete" id="hard-delete" :value="DeletionMethods.HARD_DELETE" v-model="selectedCancerforumDeleteSetting"/>
            <label for="hard-delete">
              <strong>{{ getLabel('cancerforumHardDeleteTitle') }}</strong>
              <div>{{ getLabel('cancerforumHardDeleteDescription') }}</div>
            </label>
          </li>
          <li>
            <input type="radio" name="cancerforum-delete" id="soft-delete" :value="DeletionMethods.SOFT_DELETE" v-model="selectedCancerforumDeleteSetting"/>
            <label for="soft-delete">
              <strong>{{ getLabel('cancerforumSoftDeleteTitle') }}</strong>
              <div>{{ getLabel('cancerforumSoftDeleteDescription') }}</div>
            </label>
          </li>
        </ul>
        <p v-if="displayError && !isCancerforumDeleteSettingValid" class="Form__Element__ValidationError">
          {{ getLabel('cancerforumErrorLabel') }}
        </p>
      </section>
      <section v-else-if="currentStep === FlowSteps.FRIVILLIG" class="kb-delete-profile-flow-body__step">
        <h2>
          {{ getLabel('frivilligTitle') }}
        </h2>
        <div class="kb-rich-text">
          <div class="kb-rich-text__content" v-html="decodeHtml(getLabel('frivilligDescription'))"></div>
        </div>
      </section>
      <section v-else-if="currentStep === FlowSteps.SFL" class="kb-delete-profile-flow-body__step">
        <h2>
          {{ getLabel('sflTitle') }}
        </h2>
        <div class="kb-rich-text">
          <div class="kb-rich-text__content" v-html="decodeHtml(getLabel('sflDescription'))"></div>
        </div>
      </section>

      <div class="kb-stafet-flow-actions">
        <p>
          {{ getLabel('buttonActionsDescription') }}
        </p>
  
        <div class="button-wrapper">

          <button v-if="isFirstStep" v-on:click="cancel" class="kb-button">
            {{ getLabel('cancelLabel') }}
          </button>
          <button v-else v-on:click="previousStep" class="kb-button">
            {{ getLabel('backLabel') }}
          </button>
  
          <button v-if="isLastStep" v-on:click="submit" class="kb-button kb-button--full-color-spot">
            {{ getLabel('submitLabel') }}
          </button>
          <button v-else v-on:click="nextStep" class="kb-button kb-button--full-color-spot">
            {{ nextStepLabel }}
          </button>

        </div>
      </div>

    </div>
    
    <template v-if="isSubmitting">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky">
        </div>
      </div>
    </template>
    
  </article>
</template>
